import React from 'react';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface ISwitchBoxProps {
	name: string;
	value: boolean;
	onValueChanged: (value: boolean) => void;
	label?: string;
	error?: string;
	sizeClass?: 'sm' | 'md' | 'lg';
	helpBlock?: string;
	labelSmall?: boolean;
	isDisabled?: boolean;
	hasValid?: boolean;
}

export const SwitchBox = (props: ISwitchBoxProps) => {
	const { value, error, name, label, sizeClass, isDisabled, helpBlock, labelSmall, hasValid, onValueChanged } = props;
	const showError = !!error;
    
	return (
		<div className="space-y-2">
			<div className="flex flex-row items-center space-x-3 space-y-0">
				<Switch
					id={name}
					name={name}
					checked={value}
					disabled={isDisabled}
					onCheckedChange={onValueChanged}
				/>
				{label && (
					<Label htmlFor={name} className={cn(labelSmall && "text-xs font-normal", showError && "text-destructive")}>
						{label} {hasValid && <span className='text-destructive'>(*)</span>}
					</Label>
				)}
			</div>
			{showError && <p className="text-sm font-medium text-destructive">{error}</p>}
			{helpBlock && <p className="text-sm text-muted-foreground" dangerouslySetInnerHTML={{ __html: helpBlock }} />}
		</div>
	);
};
